import { render, staticRenderFns } from "./NavbarBrand.vue?vue&type=template&id=520b5cda&"
import script from "./NavbarBrand.vue?vue&type=script&lang=js&"
export * from "./NavbarBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports